const __WEBPACK_NAMESPACE_OBJECT__ = flarum.reg.get('core', 'forum/components/GlobalPostsSearchSource');